import { StackProps, VStack } from '@chakra-ui/react';


export const FormControlHeaderStack: React.FC<StackProps> = (props) => (
  <VStack alignItems={'start'} spacing={2} pb={3} {...props} />
);
